const PATIENTS_ACCESS_ROLES = ['qarescan_user', 'tenant_admin'] as const;
const PAIRING_ACCESS_ROLES = ['qarescan_user'] as const;

function normalizeRole(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const normalized = value.trim();
  return normalized ? normalized : undefined;
}

function hasAnyRole(userRole?: unknown, expectedRoles: ReadonlyArray<string> = []): boolean {
  const normalizedUserRole = normalizeRole(userRole);
  if (!normalizedUserRole) return false;

  const normalizedExpectedRoles = new Set(
    expectedRoles.map((expectedRole) => expectedRole.toLowerCase()),
  );

  return normalizedExpectedRoles.has(normalizedUserRole.toLowerCase());
}

export function hasRecognizedAppRole(userRole?: unknown): boolean {
  return hasAnyRole(userRole, PATIENTS_ACCESS_ROLES);
}

export function canAccessPatients(userRole?: unknown): boolean {
  return hasRecognizedAppRole(userRole);
}

export function canAccessPairing(userRole?: unknown): boolean {
  return hasAnyRole(userRole, PAIRING_ACCESS_ROLES);
}
